/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Component, Input } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { FabMessageService } from '@fabric/components/message';
import {DISMISS_MSG} from '../../../common/constants';
import { ExcelExportService } from '../../../services/excel-export.service';
import { WorksheetExportRequest } from '../../models/worksheet-export-request.model';

@Component({
    selector: 'app-export-button',
    templateUrl: './export-button.component.html',
    styleUrls: ['./export-button.component.scss'],
    standalone: false
})
export class ExportButtonComponent {

  // Pass in an ExcelExportService to control which export endpoint to hit
  @Input() excelExportService: ExcelExportService;
  @Input() worksheetExportRequest: WorksheetExportRequest;
  @Input() disabled: boolean;
  @Input() color: ThemePalette = 'primary';
  @Input() buttonText = 'Export';
  @Input() buttonStyle = 'default';

  showSpinner: boolean;

  constructor(private readonly snackBar: FabMessageService) {
  }

  /**
   * Export table data to excel
   */
  exportToExcel(): void {
    this.showSpinner = true;
    if (this.worksheetExportRequest === undefined) {
      this.snackBar.displayError('Error with exporting data.', DISMISS_MSG);
      this.showSpinner = false;
    } else {
      this.excelExportService.transformToExcel(this.worksheetExportRequest).subscribe(
        (file: any) => {
          this.excelExportService.exportToExcelFromServer(file, this.worksheetExportRequest.fileName);
        },
        () => {
          this.snackBar.displayError('Error with exporting data.', DISMISS_MSG);
          this.showSpinner = false;
        }, () => {
          this.showSpinner = false;
        });
    }
  }

}
